import {IQueryParams} from "config/reducer.utils";
import axios from "axios";
import {TypedChatRoom} from "entities/chat/chat.interface";
import helpers from "helpers/index";

export async function getListChat(params: IQueryParams) {
  helpers.clearValueEmptyInObject(params)
  return await axios.get<TypedChatRoom[]>(`/chat-room/list`, {params: params})
}
